import Barcode from 'react-barcode';

interface BarcodeViewProps {
  /** Raw barcode payload to encode (the InComm `vrsBarCode` / PAN-like string). */
  value: string;
}

/**
 * Renders a scannable CODE128 barcode on a fixed white card.
 *
 * The white background + dark bars are hard-coded (independent of the
 * light/dark theme) on purpose: a cashier's scanner needs maximum contrast,
 * and an inverted barcode under dark mode would not scan. We hide the
 * library's default value caption since the human-readable reference is shown
 * separately with a copy affordance.
 */
export const BarcodeView = ({ value }: BarcodeViewProps) => {
  return (
    <div className="flex items-center justify-center rounded-2xl bg-white p-4">
      <Barcode
        value={value}
        format="CODE128"
        width={2}
        height={96}
        displayValue={false}
        margin={0}
        background="#ffffff"
        lineColor="#000000"
      />
    </div>
  );
};
